import { styled } from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  padding: 1rem 0 2rem;

  > p {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.medium.color};

    button {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.blue03.color};
      text-decoration: underline;
      padding: 0;
    }
  }
`;

export const Info = styled.p`
  position: relative;
  background-color: ${({ theme }) => theme.colors.blue_label.color};
  padding: 1.2rem 0.8rem;
  border-radius: 10px;
  max-width: 100%;
  width: 100%;
  color: ${({ theme }) => theme.colors.gray_blue.color};
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.125rem;
  margin: 0;
`;

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 2rem;
  gap: 1rem;

  h1 {
    margin-bottom: 0;
  }
`;
